import { useEffect, useRef } from "react"
import { CarrotPlanFormOption, MenuItemOptionFields, TopicOptionFields } from "./useCarrotPlanMappings"

type LastKnownOptions = {
  displayMenuItems: CarrotPlanFormOption<MenuItemOptionFields>[]
  displayTopics: CarrotPlanFormOption<TopicOptionFields>[]
  isInitialLoad: boolean
}

export function useLastKnownOptions(
  mappedFormMenuItems: CarrotPlanFormOption<MenuItemOptionFields>[],
  mappedFormTopics: CarrotPlanFormOption<TopicOptionFields>[],
  areMappingsLoading: boolean
): LastKnownOptions {
  const hasLoadedOptionsRef = useRef(false)
  const lastLoadedOptionsRef = useRef<{
    menuItems: CarrotPlanFormOption<MenuItemOptionFields>[]
    topics: CarrotPlanFormOption<TopicOptionFields>[]
  }>({
    menuItems: [],
    topics: []
  })

  useEffect(() => {
    if (!areMappingsLoading && mappedFormMenuItems.length > 0) {
      hasLoadedOptionsRef.current = true
      lastLoadedOptionsRef.current = {
        menuItems: mappedFormMenuItems,
        topics: mappedFormTopics
      }
    }
  }, [areMappingsLoading, mappedFormMenuItems, mappedFormTopics])

  const displayMenuItems = areMappingsLoading ? lastLoadedOptionsRef.current.menuItems : mappedFormMenuItems
  const displayTopics = areMappingsLoading ? lastLoadedOptionsRef.current.topics : mappedFormTopics

  return {
    displayMenuItems,
    displayTopics,
    isInitialLoad: areMappingsLoading && !hasLoadedOptionsRef.current
  }
}
